import styles from "./Conversations.module.css";
import { Modal, ListGroup,Image } from "react-bootstrap";
import { iconAssets } from '../../assets/theme/theme';
import parse from 'html-react-parser';


const Conversations = ({ messages, close, show }) => {

  const parseHtmlContent=(content)=>
  {
    return parse(content.replace(/\n/g, "").trim())
  }
  return (
    <Modal show={show} onHide={close}
      scrollable={true}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-center">Conversations</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup className={styles.chatBody}>
          {messages?.map((message, index) => (
            <div key={index} className={`${message.role === "bot" ? styles.bot : styles.user} my-2`}>
              <div>
                <div className="row">
                  {message.role === "bot" && <div className="col-1">  <Image src={iconAssets.bot} alt="" className={styles.icon}/></div>}
                  <div className={`${message.role === "bot" ? styles.botMsg : styles.userMsg} col-10`}><>{parseHtmlContent(message.content)}</></div>
                  {message.role === "user" && <div className="col-1"><Image src={iconAssets.chatUser} alt="" className={styles.icon}/></div>}
                </div>
              </div>
            </div>
          ))}
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
};

export default Conversations;
